module.exports = __webpack_public_path__ + "static/media/1986_maleRate_femaleRate.27749200.png";